import PrevButton from "components/PrevButton";
import NextButton from "components/NextButton";
import SelectInput from "components/SelectInput";
import { yearsOptions } from "constants/index";
import { adequacySkipLinkText } from "i18n/messages/buttonTitles";
import { useSideModalScrollToTop } from "hooks";

const Shares = ({
    isSharesVaild,
    setActiveStep,
    formatMessage,
    messages,
    formData,
    setFormData,
    setAdequacyStart,
    adequacyData,
    backSlideEffect = "",
    setBackSlideEffect,
    open,
    StatusAdequacy,
}) => {
    useSideModalScrollToTop();

    return (
        <>
            <div className={`shares multisteps ${backSlideEffect}`}>
                <div className="header-part">
                    <h4 className="primary-color">{formatMessage(messages.thirdHeading)}</h4>
                </div>
                <div className="content">
                    <form method="post" className="survey-form">
                        <div className="first-question">
                            <h3 className="mt-4 mb-7">{formatMessage(messages.thirdQuestion)}</h3>
                            <div className="tabs">
                                <div>
                                    <input
                                        id="sharesYes"
                                        type="radio"
                                        name="shares-experience"
                                        onChange={() =>
                                            setFormData((prevState) => ({
                                                ...prevState,
                                                shares: { ...prevState.shares, IsSharesXPConfirmed: true },
                                            }))
                                        }
                                        checked={formData?.shares?.IsSharesXPConfirmed === true}
                                    />
                                    <label
                                        className="medium mw-100"
                                        htmlFor="sharesYes"
                                        onClick={(e) =>
                                            jQuery(e.target).closest(".survey-form").find(".second-question").slideDown()
                                        }
                                    >
                                        {formatMessage(messages.yesText)}
                                    </label>
                                </div>

                                <div>
                                    <input
                                        id="sharesNo"
                                        type="radio"
                                        name="shares-experience"
                                        onChange={() =>
                                            setFormData((prevState) => ({
                                                ...prevState,
                                                shares: {
                                                    ...prevState.shares,
                                                    IsSharesXPConfirmed: false,
                                                    IsSharesXPConfirmedDate: "",
                                                },
                                            }))
                                        }
                                        checked={formData?.shares?.IsSharesXPConfirmed === false}
                                    />
                                    <label
                                        className="medium mw-100"
                                        htmlFor="sharesNo"
                                        onClick={(e) =>
                                            jQuery(e.target).closest(".survey-form").find(".second-question").slideUp()
                                        }
                                    >
                                        {formatMessage(messages.noText)}
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div
                            className="second-question"
                            style={{ display: formData?.shares?.IsSharesXPConfirmed ? "block" : "none" }}
                        >
                            <div className="border-x" />
                            <h4>{formatMessage(messages.thirdQuestionOther)}</h4>
                            <div className="">
                                <SelectInput
                                    maxMenuHeight={400}
                                    isSearchable={false}
                                    menuPlacement="top"
                                    className="select form-item"
                                    classNamePrefix="select"
                                    name="shares-experience-years"
                                    options={yearsOptions()}
                                    placeholder={formatMessage(messages.pleaseSelect)}
                                    value={formData?.shares?.IsSharesXPConfirmedDate || ""}
                                    onChange={(selectedOption) => {
                                        setFormData((prevState) => ({
                                            ...prevState,
                                            shares: { ...prevState.shares, IsSharesXPConfirmedDate: selectedOption },
                                        }));
                                    }}
                                />
                            </div>
                        </div>
                    </form>
                </div>
                {StatusAdequacy != "renew" && (
                    <span
                        onClick={() => {
                            setAdequacyStart({ step: 2 });
                            setBackSlideEffect("step-slide-right");
                        }}
                        className="skip-link"
                    >
                        {formatMessage(adequacySkipLinkText)}
                    </span>
                )}
            </div>
            {open && (
                <div className="bottom-bar-container">
                    <PrevButton
                        onClick={() => {
                            setActiveStep(2);
                            setBackSlideEffect("step-slide-right");
                        }}
                    />
                    <NextButton
                        className={`${isSharesVaild ? "" : "disable-grey"}`}
                        onClick={() => {
                            if (isSharesVaild) {
                                setAdequacyStart({
                                    step: 6,
                                    survey_second_step: { ...adequacyData.survey_second_step, ...formData, step: 4 },
                                });
                                setActiveStep(4);
                                setBackSlideEffect("step-slide-left");
                            }
                        }}
                    />
                </div>
            )}
        </>
    );
};

export default Shares;
